<template>
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28 16.3333V30.3333M28 38.5V39.6666M51.3333 28C51.3333 40.8866 40.8866 51.3333 28 51.3333C15.1133 51.3333 4.66666 40.8866 4.66666 28C4.66666 15.1133 15.1133 4.66663 28 4.66663C40.8866 4.66663 51.3333 15.1133 51.3333 28Z"
      stroke="var(--sf-base-icon-primary)"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
